// The estate documents the questionnaire records (goals.estatePlan), read as
// the codes the rest of the app keys on.
//
// The PQ's multi-select and the Salesforce picklist both use the short codes
// (Trust, Will, FPOA, MPOA, with None as the exclusive empty answer), but a
// record does not always arrive that way: the Plan Order Form and the old
// questionnaire spell the powers of attorney out ("Financial POA", "Medical
// POA"), a record built outside the app may carry the long names, and a
// Salesforce reload hands the list back comma-joined. The brief for one such
// household told the client their powers of attorney were "not recorded on the
// questionnaire" when the questionnaire plainly listed them (Jimmy,
// 2026-11-03). Every reader goes through here, so each spelling counts as the
// document it names.

const CODES = Object.freeze({
  trust: 'Trust',
  'living trust': 'Trust',
  will: 'Will',
  fpoa: 'FPOA',
  'financial poa': 'FPOA',
  'financial power of attorney': 'FPOA',
  'power of attorney for finances': 'FPOA',
  mpoa: 'MPOA',
  'medical poa': 'MPOA',
  'medical power of attorney': 'MPOA',
  'health care directive': 'MPOA',
  'healthcare directive': 'MPOA',
  none: 'None',
});

/** One recorded value as its code; a value no spelling matches comes back trimmed, as it was. */
export function estateDocCode(value) {
  const text = value === undefined || value === null ? '' : String(value).trim();
  if (!text) return '';
  return CODES[text.toLowerCase()] || text;
}

/**
 * The recorded estate documents as codes, in the order recorded and without
 * repeats. Takes the array the questionnaire keeps or the comma- (or
 * semicolon-) joined string Salesforce returns; anything else is no answer.
 */
export function estateDocCodes(value) {
  const raw = Array.isArray(value)
    ? value
    : typeof value === 'string' || typeof value === 'number'
      ? String(value).split(/[,;]/)
      : [];
  const out = [];
  for (const v of raw) {
    const code = estateDocCode(v);
    if (code && !out.includes(code)) out.push(code);
  }
  return out;
}
